export default {
  namespaced: true,
  state: {
    aliveList: []
  },
  getters: {},
  mutations: {
    // 添加
    PUSH(state: any, payload: any) {
      if (!state.aliveList.includes(payload))
        state.aliveList.push(payload)
    },
    // 移除
    REMOVE(state: any, payload: any) {
      state.aliveList = state.aliveList.filter((p: any) => p !== payload)
    },
    CLEAR(state: any) {
      state.aliveList = []
    }
  },
  actions: {}
}